import useApplyFilter from "components/Filters/useApplyFilter";
import { WebhookSuggestions, searchWebhookSuggestionsDictionary } from "constants/webhook";
import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { NamedWebhooksIntegration } from "types/generated";

const APPLY_FILTERS_SUGGESTIONS = {
  searchSuggestionsDictionary: searchWebhookSuggestionsDictionary,
};

const WebhooksTableLabelsCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<NamedWebhooksIntegration>) => {
  const { applyLabelFilter } = useApplyFilter<WebhookSuggestions>(APPLY_FILTERS_SUGGESTIONS);

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels
        tags={webhook.labels}
        applyLabelFilter={applyLabelFilter(WebhookSuggestions.Label)}
      />
    </TableSimpleCell>
  );
};

export default WebhooksTableLabelsCell;
